module.exports = __webpack_public_path__ + "img/no-preview-4.7cd30127.png";